(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["first-order-discount-popup"]) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-first-order-discount-popup]');
    const dismissedKey = 'qm_first_order_discount_dismissed_at';
    const subscribedKey = 'qm_first_order_discount_subscribed';

    roots.forEach((root) => {
      const dialog = root.querySelector('dialog');
      const closeButton = root.querySelector('[data-popup-close]');
      if (!dialog || !closeButton) return;

      root.hidden = false;

      const delayMilliseconds = Number(root.dataset.delaySeconds) * 1000;
      const scrollThreshold = Number(root.dataset.scrollPercent) / 100;
      const dismissMilliseconds = Number(root.dataset.dismissDays) * 24 * 60 * 60 * 1000;
      const submissionSuccess = root.dataset.submissionSuccess === 'true';
      const submissionError = root.dataset.submissionError === 'true';
      let previousFocus = null;
      let timerId = null;

      const readStorage = (key) => {
        try {
          return window.localStorage.getItem(key);
        } catch (error) {
          return null;
        }
      };

      const writeStorage = (key, value) => {
        try {
          window.localStorage.setItem(key, value);
        } catch (error) {
          return;
        }
      };

      const stopTriggers = () => {
        if (timerId !== null) window.clearTimeout(timerId);
        window.removeEventListener('scroll', handleScroll);
      };

      const openPopup = () => {
        if (dialog.open) return;
        stopTriggers();
        previousFocus = document.activeElement;
        dialog.showModal();
        dialog.focus();
      };

      const closePopup = (rememberDismissal = true) => {
        if (rememberDismissal) writeStorage(dismissedKey, String(Date.now()));
        if (dialog.open) dialog.close();
        if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
      };

      function handleScroll() {
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight <= 0) return;
        if (window.scrollY / scrollableHeight >= scrollThreshold) openPopup();
      }

      closeButton.addEventListener('click', () => closePopup(true));

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup(true);
      });

      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
        if (outside) closePopup(true);
      });

      if (submissionSuccess) {
        writeStorage(subscribedKey, 'true');
        openPopup();
        return;
      }

      if (submissionError) {
        openPopup();
        return;
      }

      const dismissedAt = Number(readStorage(dismissedKey)) || 0;
      const recentlyDismissed = dismissedAt > 0 && Date.now() - dismissedAt < dismissMilliseconds;
      const alreadySubscribed = readStorage(subscribedKey) === 'true';
      if (recentlyDismissed || alreadySubscribed) return;

      timerId = window.setTimeout(openPopup, delayMilliseconds);
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
